import { render, staticRenderFns } from "./WarehouseOrderPayments.vue?vue&type=template&id=bbb11d28&"
import script from "./WarehouseOrderPayments.vue?vue&type=script&lang=js&"
export * from "./WarehouseOrderPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports